export const navSections = [
  { id: "featured", label: "热门推荐" },
  { id: "action", label: "动作片" },
  { id: "scifi", label: "科幻片" },
  { id: "tv", label: "电视剧" },
  { id: "classic", label: "经典老片" },
  { id: "collections", label: "主题合集" },
  { id: "ranking", label: "热门榜单" },
  { id: "guide", label: "观影指南" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "12,600+", label: "已整理影片条目" },
  { value: "8", label: "主流类型片单" },
  { value: "96", label: "主题合集" },
  { value: "每日", label: "榜单更新频率" },
];

export const heroHighlights = [
  {
    icon: "ri-film-line",
    title: "按类型成单",
    desc: "动作、科幻、悬疑、经典老片等类型各自成单，不必在零散结果里翻找。",
  },
  {
    icon: "ri-fire-line",
    title: "榜单常新",
    desc: "热度榜、口碑榜、新剧榜分开整理，追新剧和补老片都能对症下药。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "合集打包",
    desc: "把同一主题的影片聚成合集，一次看完整条线索，省去反复搜索的麻烦。",
  },
];

export const filterTabs = [
  { key: "all", label: "全部" },
  { key: "动作片", label: "动作片" },
  { key: "科幻片", label: "科幻片" },
  { key: "电视剧", label: "电视剧" },
  { key: "经典老片", label: "经典老片" },
];

export const featuredFilms = [
  {
    id: "f1",
    title: "疾速追杀",
    original: "John Wick",
    year: 2014,
    region: "美国",
    type: "动作片",
    rating: "8.0",
    duration: "101 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20movie%20poster%20of%20an%20intense%20action%20thriller%20lone%20silhouette%20figure%20in%20a%20suit%20under%20dramatic%20amber%20streetlight%20deep%20crimson%20and%20warm%20gold%20tones%20heavy%20film%20grain%20moody%20shadows%20abstract%20geometric%20background%20high%20detail&width=600&height=900&seq=poster-john-wick-01&orientation=portrait",
    summary:
      "退休杀手因一桩旧日恩怨重回江湖，冷峻的近身格斗与夜戏光影是这部动作片最鲜明的记忆点，适合喜欢硬派打斗的观众。",
    tags: ["近身格斗", "复仇", "夜戏光影"],
  },
  {
    id: "f2",
    title: "星际穿越",
    original: "Interstellar",
    year: 2014,
    region: "美国",
    type: "科幻片",
    rating: "9.4",
    duration: "169 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20sci%20fi%20movie%20poster%20of%20a%20tiny%20astronaut%20silhouette%20before%20an%20enormous%20ringed%20planet%20deep%20indigo%20void%20and%20warm%20gold%20dust%20light%20film%20grain%20epic%20scale%20abstract%20star%20field%20high%20detail&width=600&height=900&seq=poster-interstellar-02&orientation=portrait",
    summary:
      "当家园不再宜居，一支小队穿越虫洞寻找新的可能。硬核物理设定与父女情感线交织，是科幻入门绕不开的一课。",
    tags: ["太空", "时间", "亲情线"],
  },
  {
    id: "f3",
    title: "漫长的季节",
    original: "The Long Season",
    year: 2023,
    region: "中国大陆",
    type: "电视剧",
    rating: "9.4",
    duration: "12 集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20tv%20series%20poster%20of%20a%20lonely%20figure%20walking%20past%20an%20old%20northeast%20factory%20railway%20in%20autumn%20muted%20ochre%20and%20rust%20red%20tones%20film%20grain%20nostalgic%20hazy%20light%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-long-season-03&orientation=portrait",
    summary:
      "一桩旧案串起三个家庭与一座老工业小城，用生活流叙事讲悬疑，节奏慢却后劲很足，适合喜欢现实主义题材的观众。",
    tags: ["悬疑", "年代感", "生活流"],
  },
  {
    id: "f4",
    title: "教父",
    original: "The Godfather",
    year: 1972,
    region: "美国",
    type: "经典老片",
    rating: "9.3",
    duration: "175 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20classic%20movie%20poster%20of%20a%20seated%20godfather%20figure%20in%20deep%20shadow%20dark%20wood%20study%20and%20single%20amber%20lamp%20deep%20brown%20and%20crimson%20tones%20heavy%20film%20grain%20vintage%20dramatic%20light%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-godfather-04&orientation=portrait",
    summary:
      "一个家族的兴衰与权力的代价，被写成一部长篇黑帮史诗。叙事结构与人物塑造至今仍是很多影迷反复回看的理由。",
    tags: ["黑帮", "家族", "史诗"],
  },
  {
    id: "f5",
    title: "银翼杀手2049",
    original: "Blade Runner 2049",
    year: 2017,
    region: "美国",
    type: "科幻片",
    rating: "8.4",
    duration: "164 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20sci%20fi%20movie%20poster%20of%20a%20solitary%20figure%20before%20a%20giant%20holographic%20face%20in%20amber%20fog%20orange%20smog%20and%20teal%20neon%20ruins%20film%20grain%20melancholic%20future%20city%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-blade-runner-05&orientation=portrait",
    summary:
      "在灰橙交织的未来都市里，一名复制人赏金猎人追问自己的来历。慢节奏的视觉长镜头是这部续集最被称道的部分。",
    tags: ["赛博朋克", "视觉美学", "身份追问"],
  },
  {
    id: "f6",
    title: "琅琊榜",
    original: "Nirvana in Fire",
    year: 2015,
    region: "中国大陆",
    type: "电视剧",
    rating: "9.4",
    duration: "54 集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20chinese%20period%20drama%20poster%20of%20a%20scholar%20in%20flowing%20robe%20standing%20before%20misty%20ancient%20palace%20eaves%20muted%20jade%20green%20and%20amber%20lantern%20light%20ink%20wash%20texture%20elegant%20restrained%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-nirvana-06&orientation=portrait",
    summary:
      "以权谋与复仇为主线的古装剧，把人物智商写得很高，台词和调度都相当克制，是国产权谋剧里口碑常青的一部。",
    tags: ["权谋", "古装", "群像"],
  },
];

export const actionFilms = [
  {
    id: "a1",
    title: "谍影重重",
    year: 2002,
    region: "美国",
    rating: "8.5",
    summary: "失忆特工在地中海被打捞起来，靠零碎线索反推自己的身份。手持摄影和写实动作成为后来者模仿的模板。",
    meta: "谍战 / 追逃",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20espionage%20action%20poster%20of%20a%20lone%20man%20on%20a%20cold%20european%20bridge%20at%20dawn%20muted%20grey%20blue%20and%20amber%20signal%20light%20film%20grain%20tense%20restrained%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-bourne-11&orientation=portrait",
  },
  {
    id: "a2",
    title: "突袭",
    year: 2011,
    region: "印度尼西亚",
    rating: "7.8",
    summary: "特警小队突入一栋被黑帮占据的高楼，从一层打到顶层。近身格斗密度极高，是硬核动作迷的心头好。",
    meta: "近身格斗 / 密室",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20martial%20arts%20action%20poster%20of%20silhouetted%20fighters%20inside%20a%20dark%20concrete%20stairwell%20with%20amber%20emergency%20lighting%20deep%20red%20and%20charcoal%20tones%20film%20grain%20raw%20gritty%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-raid-12&orientation=portrait",
  },
  {
    id: "a3",
    title: "疯狂的麦克斯4",
    year: 2015,
    region: "澳大利亚",
    rating: "8.7",
    summary: "末世荒漠中的一场长途追逐，几乎全程高速。实拍特技和橙蓝对比的调色，让这部续集成了动作片的视觉标杆。",
    meta: "末世 / 追车",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20post%20apocalyptic%20action%20poster%20of%20a%20lone%20war%20rig%20speeding%20across%20an%20orange%20desert%20under%20a%20burning%20sky%20vivid%20amber%20and%20deep%20teal%20tones%20film%20grain%20kinetic%20energy%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-madmax-13&orientation=portrait",
  },
  {
    id: "a4",
    title: "怒火·重案",
    year: 2021,
    region: "中国香港",
    rating: "7.4",
    summary: "警匪之间的旧账在枪火里清算，港式动作片的味道还在。枪战与近身搏杀的调度干净利落，适合怀旧港片观众。",
    meta: "警匪 / 港式动作",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20hong%20kong%20crime%20action%20poster%20of%20two%20figures%20facing%20off%20in%20a%20rainy%20neon%20alley%20amber%20and%20crimson%20reflections%20film%20grain%20moody%20noir%20atmosphere%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-raging-fire-14&orientation=portrait",
  },
];

export const scifiFilms = [
  {
    id: "s1",
    title: "降临",
    year: 2016,
    region: "美国",
    rating: "7.8",
    summary: "语言学家被派去与外星访客沟通，语言即思维。全片靠氛围和思辨推进，是软科幻里难得的情感与想象力兼顾之作。",
    meta: "外星接触 / 语言学",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20sci%20fi%20poster%20of%20a%20lone%20linguist%20before%20a%20monolithic%20alien%20vessel%20floating%20over%20a%20misty%20field%20muted%20slate%20and%20warm%20amber%20light%20film%20grain%20contemplative%20calm%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-arrival-21&orientation=portrait",
  },
  {
    id: "s2",
    title: "盗梦空间",
    year: 2010,
    region: "美国",
    rating: "9.4",
    summary: "一群人在层层梦境里植入想法，越往深处越危险。结构精巧，靠规则感支撑起整场冒险，重看常能发现新细节。",
    meta: "梦境 / 悬疑",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20sci%20fi%20poster%20of%20a%20folding%20city%20street%20curling%20upward%20with%20a%20tiny%20figure%20walking%20warm%20amber%20and%20deep%20charcoal%20tones%20film%20grain%20surreal%20geometry%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-inception-22&orientation=portrait",
  },
  {
    id: "s3",
    title: "沙丘",
    year: 2021,
    region: "美国",
    rating: "7.9",
    summary: "少年继承家族命运，卷入沙漠星球的权力争夺。巨物感与沙暴场面很有气势，配乐与音效是大银幕体验的一部分。",
    meta: "太空歌剧 / 史诗",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20sci%20fi%20epic%20poster%20of%20a%20cloaked%20figure%20on%20an%20endless%20sand%20dune%20with%20a%20colossal%20spice%20worm%20shadow%20below%20amber%20and%20bone%20tones%20film%20grain%20vast%20austere%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-dune-23&orientation=portrait",
  },
  {
    id: "s4",
    title: "第九区",
    year: 2009,
    region: "南非",
    rating: "8.3",
    summary: "外星难民被安置在约翰内斯堡的贫民区，科幻外壳下讲的是现实议题。伪纪录片质感让整件事显得格外可信。",
    meta: "外星难民 / 现实隐喻",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20sci%20fi%20poster%20of%20a%20shanty%20town%20skyline%20with%20a%20hovering%20alien%20craft%20above%20dusty%20amber%20haze%20and%20rusted%20metal%20tones%20film%20grain%20documentary%20realism%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-district9-24&orientation=portrait",
  },
];

export const tvSeries = [
  {
    id: "t1",
    title: "白夜追凶",
    year: 2017,
    region: "中国大陆",
    rating: "9.0",
    episodes: "32 集",
    summary: "一对双胞胎兄弟共用身份查案，一人白天、一人夜里。设定新颖，悬念铺得稳，是国产刑侦剧里被反复提起的样本。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20crime%20series%20poster%20of%20two%20identical%20men%20split%20by%20light%20and%20shadow%20in%20a%20rainy%20city%20street%20amber%20and%20deep%20teal%20tones%20film%20grain%20tense%20noir%20mood%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-daynight-31&orientation=portrait",
  },
  {
    id: "t2",
    title: "切尔诺贝利",
    year: 2019,
    region: "美国 / 英国",
    rating: "9.6",
    episodes: "5 集",
    summary: "以核事故为背景的迷你剧，把灾难发生的链条与后果讲得清楚而克制。节奏紧张，适合一次看完的短剧爱好者。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20drama%20series%20poster%20of%20a%20lone%20firefighter%20before%20a%20silhouetted%20reactor%20building%20at%20dusk%20muted%20ash%20grey%20and%20amber%20glow%20film%20grain%20somber%20hushed%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-chernobyl-32&orientation=portrait",
  },
  {
    id: "t3",
    title: "权力的游戏",
    year: 2011,
    region: "美国",
    rating: "9.3",
    episodes: "73 集",
    summary: "多个家族为铁王座角力，人物线庞杂却各有去处。宏大世界观与不按套路出牌的人物命运，是它当年出圈的原因。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20fantasy%20series%20poster%20of%20an%20iron%20throne%20in%20a%20dark%20hall%20lit%20by%20amber%20torchlight%20deep%20crimson%20and%20charcoal%20tones%20film%20grain%20dramatic%20solemn%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-got-33&orientation=portrait",
  },
  {
    id: "t4",
    title: "黑镜",
    year: 2011,
    region: "英国",
    rating: "9.0",
    episodes: "单元剧",
    summary: "每集独立的故事，用科技设定照见人性的暗面。篇幅短、脑洞大，适合碎片时间挑着看，不用按顺序补。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20anthology%20series%20poster%20of%20a%20cracked%20dark%20mirror%20screen%20reflecting%20a%20pale%20face%20muted%20slate%20and%20amber%20glow%20film%20grain%20cold%20dystopian%20mood%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-blackmirror-34&orientation=portrait",
  },
];

export const classicFilms = [
  {
    id: "c1",
    title: "罗马假日",
    year: 1953,
    region: "美国",
    rating: "9.1",
    era: "1950s",
    summary: "出逃的公主与记者在罗马度过一天，轻松又带点遗憾。黑白影像里的城市漫游，是被反复重刷的浪漫范本。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20vintage%20romance%20poster%20of%20a%20young%20woman%20on%20a%20vespa%20in%20sunlit%20rome%20streets%20warm%20sepia%20and%20amber%20tones%20film%20grain%20nostalgic%20soft%20light%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-roman-holiday-41&orientation=portrait",
  },
  {
    id: "c2",
    title: "肖申克的救赎",
    year: 1994,
    region: "美国",
    rating: "9.7",
    era: "1990s",
    summary: "一场漫长的越狱，也是一个人对自由的坚持。故事扎实，情绪克制，是许多人心里反复排在前列的经典。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20prison%20drama%20poster%20of%20a%20man%20looking%20up%20at%20a%20narrow%20sliver%20of%20sky%20between%20stone%20walls%20muted%20grey%20and%20warm%20amber%20light%20film%20grain%20hopeful%20quiet%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-shawshank-42&orientation=portrait",
  },
  {
    id: "c3",
    title: "霸王别姬",
    year: 1993,
    region: "中国大陆",
    rating: "9.6",
    era: "1990s",
    summary: "两个京剧伶人的半生纠葛，映照时代变迁。戏与人生交织，表演与调度都极具分量，是华语影史常被提及的作品。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20chinese%20opera%20drama%20poster%20of%20two%20performers%20in%20elaborate%20headdress%20under%20stage%20lighting%20deep%20crimson%20and%20gold%20tones%20film%20grain%20theatrical%20elegant%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-farewell-43&orientation=portrait",
  },
  {
    id: "c4",
    title: "天堂电影院",
    year: 1988,
    region: "意大利",
    rating: "9.2",
    era: "1980s",
    summary: "小镇放映师与少年影迷的忘年情谊，关于电影本身的情书。舒缓、怀旧，适合在安静的夜里慢慢看。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20minimalist%20nostalgic%20cinema%20poster%20of%20an%20old%20projector%20beam%20cutting%20through%20dusty%20amber%20light%20in%20a%20vintage%20theatre%20warm%20sepia%20tones%20film%20grain%20wistful%20tender%20abstract%20background%20high%20detail&width=600&height=900&seq=poster-cinema-paradiso-44&orientation=portrait",
  },
];

export const collections = [
  {
    id: "col1",
    title: "一口气看完的硬核动作",
    count: "24 部",
    accent: "primary",
    desc: "从近身格斗到高速追车，挑的都是节奏紧、时长可控、适合连看的动作片。",
    items: ["疾速追杀", "突袭", "疯狂的麦克斯4", "谍影重重", "怒火·重案", "飓风营救"],
  },
  {
    id: "col2",
    title: "科幻入门不踩雷",
    count: "18 部",
    accent: "secondary",
    desc: "设定友好、门槛不高，既能看热闹也能看门道，适合刚开始接触科幻的观众。",
    items: ["星际穿越", "降临", "盗梦空间", "第九区", "沙丘", "银翼杀手2049"],
  },
  {
    id: "col3",
    title: "值得重看的经典老片",
    count: "31 部",
    accent: "accent",
    desc: "跨越几十年的老电影，故事与表演都经得起时间，适合周末慢慢重温。",
    items: ["教父", "罗马假日", "肖申克的救赎", "霸王别姬", "天堂电影院", "十二怒汉"],
  },
  {
    id: "col4",
    title: "短剧速刷清单",
    count: "15 部",
    accent: "primary",
    desc: "集数少、单集短，一个晚上或一个周末就能追完，通勤摸鱼都合适。",
    items: ["切尔诺贝利", "白夜追凶", "黑镜", "西部世界（第一季）", "漫长的季节", "沉默的真相"],
  },
];

export const rankingTabs = [
  {
    key: "heat",
    label: "热度榜",
    items: [
      { rank: 1, title: "星际穿越", type: "科幻片", trend: "up", score: "9.4" },
      { rank: 2, title: "漫长的季节", type: "电视剧", trend: "same", score: "9.4" },
      { rank: 3, title: "疾速追杀", type: "动作片", trend: "up", score: "8.0" },
      { rank: 4, title: "琅琊榜", type: "电视剧", trend: "down", score: "9.4" },
      { rank: 5, title: "银翼杀手2049", type: "科幻片", trend: "up", score: "8.4" },
    ],
  },
  {
    key: "rating",
    label: "口碑榜",
    items: [
      { rank: 1, title: "肖申克的救赎", type: "经典老片", trend: "same", score: "9.7" },
      { rank: 2, title: "霸王别姬", type: "经典老片", trend: "same", score: "9.6" },
      { rank: 3, title: "切尔诺贝利", type: "电视剧", trend: "up", score: "9.6" },
      { rank: 4, title: "教父", type: "经典老片", trend: "same", score: "9.3" },
      { rank: 5, title: "盗梦空间", type: "科幻片", trend: "down", score: "9.4" },
    ],
  },
  {
    key: "new",
    label: "新剧榜",
    items: [
      { rank: 1, title: "漫长的季节", type: "电视剧", trend: "up", score: "9.4" },
      { rank: 2, title: "白夜追凶", type: "电视剧", trend: "up", score: "9.0" },
      { rank: 3, title: "沙丘", type: "科幻片", trend: "same", score: "7.9" },
      { rank: 4, title: "怒火·重案", type: "动作片", trend: "down", score: "7.4" },
      { rank: 5, title: "黑镜", type: "电视剧", trend: "up", score: "9.0" },
    ],
  },
];

export const guides = [
  {
    step: "01",
    title: "先定类型，再挑片子",
    desc: "想放松就打开动作片或喜剧向片单，想动脑就进科幻和悬疑。先圈定类型，能省掉一大半翻找时间。",
  },
  {
    step: "02",
    title: "按时间预算选片长",
    desc: "只有一小时就用短剧或迷你剧；周末有整块时间，再上时长两三个小时的电影和长篇剧集。",
  },
  {
    step: "03",
    title: "从榜单和合集入手",
    desc: "拿不定主意时，先看热度榜和口碑榜，或者直接进主题合集，跟着一条线索挑，比自己乱翻高效。",
  },
  {
    step: "04",
    title: "老片新看，注意版本",
    desc: "经典老片常有修复版或不同剪辑版本，观感差别不小，先确认片长和版本再决定从哪一版看起。",
  },
];

export const faqs = [
  {
    q: "神马影院这个页面主要提供什么？",
    a: "本页把神马影院相关的电影、电视剧、动作片、科幻片和经典老片，按类型整理成一份可浏览的片单，并用榜单、合集和观影指南帮你快速定位想看的内容，减少到处搜索的时间。",
  },
  {
    q: "片单里的条目是自动生成的吗？",
    a: "片单条目由编辑按类型和主题人工整理归类，同一类型相对集中，方便你顺着一条线索往下挑，而不是拿到一堆杂乱的结果。",
  },
  {
    q: "搜索和筛选能查到全部资源吗？",
    a: "页面顶部的搜索和类型筛选只作用于本页已经展示的内容，用来帮你更快定位页面内的片单条目，不会跳转到站外，也不会发起任何网络请求。",
  },
  {
    q: "榜单多久更新一次？",
    a: "热度榜、口碑榜和新剧榜的更新频率以页面标注为准，不同榜单的侧重不一样，可以结合类型筛选一起用，找到更贴合自己口味的片子。",
  },
  {
    q: "我没看过科幻片，从哪里开始比较好？",
    a: "建议先从合集「科幻入门不踩雷」里挑一部设定相对简单、情节好懂的作品，比如以情感线为主的片目，适应之后再去看设定更复杂的作品。",
  },
];